import b from 'b_';
import { Image } from 'platform-components';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import Slide from '../__slide/how-to-start-modal__slide';

interface Props {
    intl: IntlShape;
}

const HowToStartModalDesktopView = ({ intl }: Props) => {
    const firstArrowImgSrc = intl.formatMessage({ id: 'howToStartModal.firstArrow.image.src' });
    const secondArrowImgSrc = intl.formatMessage({ id: 'howToStartModal.secondArrow.image.src' });

    return (
        <>
            <Slide
                imgKey="howToStartModal.firstColumn.image.src"
                markdownId="howToStartModal.firstColumn.title"
                textId="howToStartModal.firstColumn.text"
            />
            <Image alt="" className="how-to-start-modal__arrow" src={firstArrowImgSrc} />
            <Slide
                imgKey="howToStartModal.secondColumn.image.src"
                markdownId="howToStartModal.secondColumn.title"
                textId="howToStartModal.secondColumn.text"
            />
            <Image alt="" className={b('how-to-start-modal', 'arrow', { second: true })} src={secondArrowImgSrc} />
            <Slide
                imgKey="howToStartModal.thirdColumn.image.src"
                markdownId="howToStartModal.thirdColumn.title"
                textId="howToStartModal.thirdColumn.text"
            />
        </>
    );
};

export default injectIntl(HowToStartModalDesktopView);
